import { FileTextIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';

import { QuoteCard } from './quote-card';
import type { Quote } from './types';

interface Props {
  quotes: Quote[];
  onSelect: (quote: Quote) => void;
}

export function QuotesGrid({ quotes, onSelect }: Props) {
  const { t } = useLanguage();

  if (quotes.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-3 text-center border rounded-xl bg-card">
        <FileTextIcon className="w-10 h-10 text-muted-foreground/40" />
        <p className="font-medium text-sm">{t.noQuotesFound}</p>
        <p className="text-xs text-muted-foreground">{t.noQuotesDescription}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {quotes.map((quote) => (
        <QuoteCard key={quote.id} quote={quote} onSelect={onSelect} />
      ))}
    </div>
  );
}
